import React, {useState} from 'react';
// Import Swiper styles
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/navigation';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/pagination';
// Import Swiper core and required modules
// eslint-disable-next-line import/no-unresolved
import {Swiper, SwiperSlide} from 'swiper/react';
// eslint-disable-next-line import/no-unresolved
import {EffectFade, Keyboard, Navigation, Virtual} from 'swiper/modules';

import FramedImage from './FramedImage';

type ImageSliderProps = {
  images: {url: string; spreadFrame: [number, number][][]; id: number; imageRefs: number[]; has_geom_frame: boolean}[];
  onClose: () => void;
};

const ImageSlider = ({images, onClose}: ImageSliderProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState<boolean>(true);


  console.log('images before swiper', images);
  return (
    <div className="w-screen h-screen fixed z-10 bg-black/70 flex items-center justify-center px-5">
      <div className="bg-white rounded-lg overflow-hidden relative">
        {/* Close Button */}
        {onClose && (
          <button
            onClick={onClose}
            className="absolute top-1 right-3 z-20 text-white bg-black/50 rounded-full px-3 mr-3"
          >
            &#10005;
          </button>
        )}

        {/* Swiper Slider */}
        <Swiper
          modules={[Navigation, Keyboard, EffectFade, Virtual]}
          spaceBetween={30}
          navigation={true}
          keyboard={{enabled: true}}
          // effect="fade" // Not to use because than graphics cannot be clicked
          lazyPreloadPrevNext={6} // Load next 3 and previous 3 slides lazily
          direction="horizontal" // ✅ force horizontal
          slidesPerView={1} // ✅ only one slide at a time
          loop={true}
          onSlideChange={(swiper: any) => {
            setActiveIndex(swiper.realIndex); // use realIndex with loop
          }}
          className="w-[70vw] max-h-[90vh]"
        >
          {images.map((img, index) => {
            // Only render slides near the active one
            const distance = Math.abs(activeIndex - index);
            const shouldRender =
              distance <= 3 || // within ±3
              distance >= images.length - 3; // handle loop-around

            if (!shouldRender) {
              return <SwiperSlide key={img.id}></SwiperSlide>;
            }

            return (
              <SwiperSlide key={img.id}>
                <FramedImage
                  index={index}
                  frames={img.spreadFrame.map((polygon) => ({
                    href: img.url,
                    coordinates: polygon,
                    imgRefs: img.imageRefs,
                    has_geom_frame: img.has_geom_frame,
                  }))}
                  id={img.id}
                  isActiveSlide={activeIndex === index}
                  onClose={onClose}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
        {/*<h1 className="p-2 text-center truncate ">'TEST'</h1>*/}
      </div>
    </div>
  );
};

export default ImageSlider;
